module.exports = __webpack_public_path__ + "046daa679f5c6090178e4706bec06533.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/rep-trade.png
// module id = 1534
// module chunks = 0